import src from "IMAGE";
export default { src, width: 384, height: 117, blurWidth: 0, blurHeight: 0};
